<template>
  <!-- 银行账户 -->
  <div class="transferList">
    <div style="padding: 20px 20px; background:white; border-radius:3px">
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" stripe border>
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="DEPOSIT_BANK" label="开户银行" min-width="80"></el-table-column>
            <el-table-column prop="ACCOUNT_NUM" label="账户号码" min-width="80"></el-table-column>
            <el-table-column label="账户类型" min-width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.ACCOUNT_TYPE === 1">基本存款账户</span>
                <span v-if="scope.row.ACCOUNT_TYPE === 2">一般存款账户</span>
                <span v-if="scope.row.ACCOUNT_TYPE === 3">临时存款账户</span>
                <span v-if="scope.row.ACCOUNT_TYPE === 4">专用存款账户</span>
              </template>
            </el-table-column>
            <el-table-column prop="BALANCE" label="账户余额" min-width="80"></el-table-column>
            <el-table-column prop="UPDATE_TIME" label="更新时间" min-width="50"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-view" size="small" @click="update(scope.row)">更新余额</el-button>
                <el-button type="text" icon="el-icon-view" size="small" @click="detail(scope.row)">详情</el-button>
                <el-button type="text" icon="el-icon-view" size="small" style="color:red" @click="change(scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      formLableWidth: '120px',
      COUNTS: [],
      //   servicetype: [
      //     {
      //       label: '基本存款账户',
      //       value: '1'
      //     },
      //     {
      //       label: '一般存款账户',
      //       value: '2'
      //     },
      //     {
      //       label: '临时存款账户',
      //       value: '3'
      //     },
      //     {
      //       label: '专用存款账户',
      //       value: '4'
      //     }
      //   ],
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      total_count: 0,
      tableData: [],
      // 新建开户
      //   creatAccountVisible: false,
      //   DEPOSIT_BANK: '',
      //   ACCOUNT_NUM: '',
      //   ACCOUNT_TYPE: '',
      //   BALANCE: '',
      // 更新余额数据
      //   updateForm: {},
      //   updateVisible: false,
      //   // 修改所需数据
      //   changeVisible: false,
      //   changeForm: {},
      //   releteCompanyId:0
    };
  },
  computed: {
    ADJUSTDOCUMENTLIST_DATA_CONDITION() {
      return this.$store.state.ADJUSTDOCUMENTLIST_DATA_CONDITION;
    },
  },
  methods: {
    queryDocument() {
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 6,
        TC_ID: this.releteCompanyId,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      http.post(params).then((result) => {
        if (result[0].LIST.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
          this.total_count = 0;
        }
        if (result[0].LIST) {
          this.tableData = result[0].LIST;
          this.total_count = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.total_count = 0;
        }
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
  },
  created() {
    this.queryDocument();
  },
};
</script>
<style scoped>
/* .transferList {
  font-size: 14px;
  color: #606266;
}
.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding: 0 40px;
  margin: 0 -20px 0 -20px;
}
.search {
  width: 100%;
}
.searchForm {
  border-radius: 3px;
  background: white;
  padding: 20px 20px 10px;
} */
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/cashFlow.vue